import React from 'react';

const ScreenPreview = () => {
  return <div>ScreenPreview</div>;
};

export default ScreenPreview;
